function PlanL({ ...props }) {
	return (
		<g {...props} id="unit-l">
			<g id="furniture">
				<polyline
					points="419.06 635.5 419.06 633.52 422.97 633.52 422.97 635.5 419.06 635.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="342.65"
					y1="403.8"
					x2="501.14"
					y2="403.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.53"
					y1="433.53"
					x2="453.77"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.92"
					y1="433.53"
					x2="446.16"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.31"
					y1="433.53"
					x2="438.55"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.7"
					y1="433.53"
					x2="430.93"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.08"
					y1="433.53"
					x2="423.33"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.47"
					y1="433.53"
					x2="415.72"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.86"
					y1="433.53"
					x2="408.1"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.25"
					y1="433.53"
					x2="400.49"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.63"
					y1="433.53"
					x2="392.88"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.02"
					y1="433.53"
					x2="385.27"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.41"
					y1="433.53"
					x2="377.65"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.8"
					y1="433.53"
					x2="370.04"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.19"
					y1="433.53"
					x2="362.43"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.65"
					y1="410.62"
					x2="342.65"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.65"
					y1="405.78"
					x2="344.35"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.21"
					y1="405.78"
					x2="351.96"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.82"
					y1="405.78"
					x2="359.58"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.43"
					y1="405.78"
					x2="367.19"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.04"
					y1="405.78"
					x2="374.8"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.65"
					y1="405.78"
					x2="382.41"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.27"
					y1="405.78"
					x2="390.02"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.88"
					y1="405.78"
					x2="397.63"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.49"
					y1="405.78"
					x2="405.25"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.1"
					y1="405.78"
					x2="412.86"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.72"
					y1="405.78"
					x2="420.47"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.33"
					y1="405.78"
					x2="428.08"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.93"
					y1="405.78"
					x2="435.7"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.55"
					y1="405.78"
					x2="443.31"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.16"
					y1="405.78"
					x2="450.92"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.77"
					y1="405.78"
					x2="458.53"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.38"
					y1="405.78"
					x2="466.14"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469"
					y1="405.78"
					x2="473.75"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.61"
					y1="405.78"
					x2="481.36"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.22"
					y1="405.78"
					x2="488.98"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.83"
					y1="405.78"
					x2="496.59"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.44"
					y1="405.78"
					x2="501.14"
					y2="405.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="405.78"
					x2="501.14"
					y2="410.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="413.47"
					x2="501.14"
					y2="418.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="453.24 838.68 506.76 838.68 506.76 892.2 453.24 892.2 453.24 838.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="742.5 299.56 738.21 299.56 738.21 337.06 742.5 337.06 742.5 299.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="742.89 338.63 742.89 298 742.5 298 742.5 338.63 742.89 338.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="742.5"
					y1="338.63"
					x2="742.89"
					y2="338.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="298"
					x2="742.5"
					y2="338.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.89"
					y1="298"
					x2="742.5"
					y2="298"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.89"
					y1="338.63"
					x2="742.89"
					y2="298"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.21"
					y1="299.56"
					x2="738.21"
					y2="337.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="337.06"
					x2="742.5"
					y2="299.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.21 296.05 738.21 299.56 742.5 299.56 742.5 296.05 738.21 296.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="742.5"
					y1="296.05"
					x2="738.21"
					y2="296.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="299.56"
					x2="742.5"
					y2="296.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.21"
					y1="299.56"
					x2="742.5"
					y2="299.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.21"
					y1="296.05"
					x2="738.21"
					y2="299.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="742.5 340.58 742.5 337.06 738.21 337.06 738.21 340.58 742.5 340.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.21"
					y1="340.58"
					x2="742.5"
					y2="340.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.21"
					y1="337.06"
					x2="738.21"
					y2="340.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="337.06"
					x2="738.21"
					y2="337.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="340.58"
					x2="742.5"
					y2="337.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="299.56"
					x2="741.72"
					y2="337.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.6 294.49 738.6 296.05 742.5 296.05 742.5 298 742.89 298 742.89 294.49 738.6 294.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="742.89"
					y1="294.49"
					x2="738.6"
					y2="294.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.89"
					y1="298"
					x2="742.89"
					y2="294.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="298"
					x2="742.89"
					y2="298"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="296.05"
					x2="742.5"
					y2="298"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="296.05"
					x2="742.5"
					y2="296.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="294.49"
					x2="738.6"
					y2="296.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="742.89 342.14 742.89 338.63 742.5 338.63 742.5 340.58 738.6 340.58 738.6 342.14 742.89 342.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.6"
					y1="342.14"
					x2="742.89"
					y2="342.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="340.58"
					x2="738.6"
					y2="342.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="340.58"
					x2="738.6"
					y2="340.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="338.63"
					x2="742.5"
					y2="340.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.89"
					y1="338.63"
					x2="742.5"
					y2="338.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.89"
					y1="342.14"
					x2="742.89"
					y2="338.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.72 344.12 739.74 344.12 739.74 445.81 741.72 445.81 741.72 344.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.72"
					y1="445.81"
					x2="741.72"
					y2="344.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.74"
					y1="445.81"
					x2="741.72"
					y2="445.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.74"
					y1="344.12"
					x2="739.74"
					y2="445.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="344.12"
					x2="739.74"
					y2="344.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.72 294.49 729.83 294.49 729.83 290.52 741.72 290.52 741.72 294.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="729.83"
					y1="294.49"
					x2="741.72"
					y2="294.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.83"
					y1="290.52"
					x2="729.83"
					y2="294.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="290.52"
					x2="729.83"
					y2="290.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="294.49"
					x2="741.72"
					y2="290.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.72 346.1 729.83 346.1 729.83 342.14 741.72 342.14 741.72 346.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="729.83"
					y1="346.1"
					x2="741.72"
					y2="346.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.83"
					y1="342.14"
					x2="729.83"
					y2="346.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="342.14"
					x2="729.83"
					y2="342.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="346.1"
					x2="741.72"
					y2="342.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.72 447.79 729.83 447.79 729.83 443.83 741.72 443.83 741.72 447.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="729.83"
					y1="447.79"
					x2="741.72"
					y2="447.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.83"
					y1="443.83"
					x2="729.83"
					y2="447.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="443.83"
					x2="729.83"
					y2="443.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="447.79"
					x2="741.72"
					y2="443.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="364.44 53.18 364.44 57.48 401.94 57.48 401.94 53.18 364.44 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="403.5 52.79 362.88 52.79 362.88 53.18 403.5 53.18 403.5 52.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="403.5"
					y1="53.18"
					x2="403.5"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.88"
					y1="53.18"
					x2="403.5"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.88"
					y1="52.79"
					x2="362.88"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.5"
					y1="52.79"
					x2="362.88"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.44"
					y1="57.48"
					x2="401.94"
					y2="57.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.94"
					y1="53.18"
					x2="364.44"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="360.93 57.48 364.44 57.48 364.44 53.18 360.93 53.18 360.93 57.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="360.93"
					y1="53.18"
					x2="360.93"
					y2="57.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.44"
					y1="53.18"
					x2="360.93"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.44"
					y1="57.48"
					x2="364.44"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.93"
					y1="57.48"
					x2="364.44"
					y2="57.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="405.45 53.18 401.94 53.18 401.94 57.48 405.45 57.48 405.45 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="405.45"
					y1="57.48"
					x2="405.45"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.94"
					y1="57.48"
					x2="405.45"
					y2="57.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.94"
					y1="53.18"
					x2="401.94"
					y2="57.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.45"
					y1="53.18"
					x2="401.94"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.44"
					y1="53.96"
					x2="401.94"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="359.37 57.09 360.93 57.09 360.93 53.18 362.88 53.18 362.88 52.79 359.37 52.79 359.37 57.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.37"
					y1="52.79"
					x2="359.37"
					y2="57.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.88"
					y1="52.79"
					x2="359.37"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.88"
					y1="53.18"
					x2="362.88"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.93"
					y1="53.18"
					x2="362.88"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.93"
					y1="57.09"
					x2="360.93"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.37"
					y1="57.09"
					x2="360.93"
					y2="57.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="407.01 52.79 403.5 52.79 403.5 53.18 405.45 53.18 405.45 57.09 407.01 57.09 407.01 52.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="407.01"
					y1="57.09"
					x2="407.01"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.45"
					y1="57.09"
					x2="407.01"
					y2="57.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.45"
					y1="53.18"
					x2="405.45"
					y2="57.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.5"
					y1="53.18"
					x2="405.45"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.5"
					y1="52.79"
					x2="403.5"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.01"
					y1="52.79"
					x2="403.5"
					y2="52.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="409 53.96 409 55.95 499.16 55.95 499.16 53.96 409 53.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="499.16"
					y1="53.96"
					x2="409"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.16"
					y1="55.95"
					x2="499.16"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409"
					y1="55.95"
					x2="499.16"
					y2="55.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409"
					y1="53.96"
					x2="409"
					y2="55.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="359.37 53.96 359.37 65.86 355.4 65.86 355.4 53.96 359.37 53.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.37"
					y1="65.86"
					x2="359.37"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.4"
					y1="65.86"
					x2="359.37"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.4"
					y1="53.96"
					x2="355.4"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.37"
					y1="53.96"
					x2="355.4"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="410.98 53.96 410.98 65.86 407.01 65.86 407.01 53.96 410.98 53.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="410.98"
					y1="65.86"
					x2="410.98"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.01"
					y1="65.86"
					x2="410.98"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.01"
					y1="53.96"
					x2="407.01"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.98"
					y1="53.96"
					x2="407.01"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="501.14 53.96 501.14 65.86 497.18 65.86 497.18 53.96 501.14 53.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="501.14"
					y1="65.86"
					x2="501.14"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.18"
					y1="65.86"
					x2="501.14"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.18"
					y1="53.96"
					x2="497.18"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="53.96"
					x2="497.18"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="724.97 111.92 723.06 112.45 739.76 172.79 741.67 172.26 724.97 111.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.67"
					y1="172.26"
					x2="724.97"
					y2="111.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.76"
					y1="172.79"
					x2="741.67"
					y2="172.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.06"
					y1="112.45"
					x2="739.76"
					y2="172.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.97"
					y1="111.92"
					x2="723.06"
					y2="112.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="682.59 70.03 681.2 71.44 723.25 112.77 724.64 111.36 682.59 70.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="724.64"
					y1="111.36"
					x2="682.59"
					y2="70.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.25"
					y1="112.77"
					x2="724.64"
					y2="111.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.2"
					y1="71.44"
					x2="723.25"
					y2="112.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.59"
					y1="70.03"
					x2="681.2"
					y2="71.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="624.36 54 623.84 55.91 681.53 71.63 682.05 69.72 624.36 54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="682.05"
					y1="69.72"
					x2="624.36"
					y2="54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.53"
					y1="71.63"
					x2="682.05"
					y2="69.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.84"
					y1="55.91"
					x2="681.53"
					y2="71.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.36"
					y1="54"
					x2="623.84"
					y2="55.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="684.06 70.82 678.14 81.13 674.7 79.16 680.63 68.84 684.06 70.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="678.14"
					y1="81.13"
					x2="684.06"
					y2="70.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.7"
					y1="79.16"
					x2="678.14"
					y2="81.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.63"
					y1="68.84"
					x2="674.7"
					y2="79.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.06"
					y1="70.82"
					x2="680.63"
					y2="68.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="725.85 113.32 715.6 119.35 713.59 115.94 723.84 109.9 725.85 113.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="715.6"
					y1="119.35"
					x2="725.85"
					y2="113.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.59"
					y1="115.94"
					x2="715.6"
					y2="119.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.84"
					y1="109.9"
					x2="713.59"
					y2="115.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.85"
					y1="113.32"
					x2="723.84"
					y2="109.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.77"
					y1="839.21"
					x2="351.8"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="351.8"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="354.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="839.21"
					x2="421.18"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="421.18"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="418.2"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="839.21"
					x2="423.21"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<polyline
					points="417.21 840.2 421.18 840.2 421.18 839.21 417.21 839.21 417.21 840.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.76 839.21 351.8 839.21 351.8 840.2 355.76 840.2 355.76 839.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.21 823.36 421.18 823.36 421.18 822.36 417.21 822.36 417.21 823.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.76 822.36 351.8 822.36 351.8 823.36 355.76 823.36 355.76 822.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="417.21"
					y1="840.2"
					x2="421.18"
					y2="840.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.18"
					y1="840.2"
					x2="421.18"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.18"
					y1="839.21"
					x2="417.21"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.21"
					y1="839.21"
					x2="417.21"
					y2="840.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.76"
					y1="839.21"
					x2="351.8"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.8"
					y1="839.21"
					x2="351.8"
					y2="840.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.8"
					y1="840.2"
					x2="355.76"
					y2="840.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.76"
					y1="840.2"
					x2="355.76"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.21"
					y1="823.36"
					x2="421.18"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.18"
					y1="823.36"
					x2="421.18"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.18"
					y1="822.36"
					x2="417.21"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.21"
					y1="822.36"
					x2="417.21"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.76"
					y1="822.36"
					x2="351.8"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.8"
					y1="822.36"
					x2="351.8"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.8"
					y1="823.36"
					x2="355.76"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.76"
					y1="823.36"
					x2="355.76"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="416.22 839.21 417.71 839.21 417.71 823.36 416.22 823.36 416.22 839.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.27 839.21 356.75 839.21 356.75 823.36 355.27 823.36 355.27 839.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="398.8 781.31 356.75 823.36 359.21 825.81 401.26 783.76 398.8 781.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="417.71"
					y1="823.36"
					x2="418.2"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.71"
					y1="839.21"
					x2="418.2"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="418.2"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.27"
					y1="823.36"
					x2="354.77"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.27"
					y1="839.21"
					x2="354.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="354.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.22"
					y1="839.21"
					x2="416.22"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.22"
					y1="823.36"
					x2="417.71"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.71"
					y1="823.36"
					x2="417.71"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.71"
					y1="839.21"
					x2="416.22"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.27"
					y1="839.21"
					x2="355.27"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.27"
					y1="823.36"
					x2="356.75"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.75"
					y1="823.36"
					x2="356.75"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.75"
					y1="839.21"
					x2="355.27"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.8"
					y1="781.31"
					x2="401.26"
					y2="783.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.26"
					y1="783.76"
					x2="359.21"
					y2="825.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.21"
					y1="825.81"
					x2="356.75"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.75"
					y1="823.36"
					x2="398.8"
					y2="781.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="418.2"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="418.2"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="421.18"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="823.36"
					x2="421.18"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="839.21"
					x2="421.18"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="418.2"
					y1="839.21"
					x2="421.18"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="354.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="354.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="351.8"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="823.36"
					x2="351.8"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="839.21"
					x2="351.8"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="354.77"
					y1="839.21"
					x2="351.8"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="745.68"
					y1="447.79"
					x2="729.83"
					y2="447.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="50"
					x2="501.14"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="624.03"
					y1="65.86"
					x2="624.03"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="833.27"
					x2="514.69"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="514.69"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="511.72"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="833.27"
					x2="445.31"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="445.31"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="448.29"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<polyline
					points="449.28 834.26 449.28 833.27 445.31 833.27 445.31 834.26 449.28 834.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="510.73 833.27 510.73 834.26 514.69 834.26 514.69 833.27 510.73 833.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.28 823.36 449.28 822.36 445.31 822.36 445.31 823.36 449.28 823.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="510.73 822.36 510.73 823.36 514.69 823.36 514.69 822.36 510.73 822.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="449.28"
					y1="834.26"
					x2="445.31"
					y2="834.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.31"
					y1="834.26"
					x2="445.31"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.31"
					y1="833.27"
					x2="449.28"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.28"
					y1="833.27"
					x2="449.28"
					y2="834.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.73"
					y1="833.27"
					x2="514.69"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.69"
					y1="833.27"
					x2="514.69"
					y2="834.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.69"
					y1="834.26"
					x2="510.73"
					y2="834.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.73"
					y1="834.26"
					x2="510.73"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.28"
					y1="823.36"
					x2="445.31"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.31"
					y1="823.36"
					x2="445.31"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.31"
					y1="822.36"
					x2="449.28"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.28"
					y1="822.36"
					x2="449.28"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.73"
					y1="822.36"
					x2="514.69"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.69"
					y1="822.36"
					x2="514.69"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.69"
					y1="823.36"
					x2="510.73"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.73"
					y1="823.36"
					x2="510.73"
					y2="822.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="450.27 833.27 450.27 823.36 448.78 823.36 448.78 833.27 450.27 833.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="511.22 833.27 511.22 823.36 509.73 823.36 509.73 833.27 511.22 833.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="467.69 781.31 465.23 783.76 507.28 825.81 509.73 823.36 467.69 781.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="448.78"
					y1="823.36"
					x2="448.29"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.78"
					y1="833.27"
					x2="448.29"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="448.29"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.22"
					y1="823.36"
					x2="511.72"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.22"
					y1="833.27"
					x2="511.72"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="511.72"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.27"
					y1="833.27"
					x2="450.27"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.27"
					y1="823.36"
					x2="448.78"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.78"
					y1="823.36"
					x2="448.78"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.78"
					y1="833.27"
					x2="450.27"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.22"
					y1="833.27"
					x2="511.22"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.22"
					y1="823.36"
					x2="509.73"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.73"
					y1="823.36"
					x2="509.73"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.73"
					y1="833.27"
					x2="511.22"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.69"
					y1="781.31"
					x2="465.23"
					y2="783.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.23"
					y1="783.76"
					x2="507.28"
					y2="825.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.28"
					y1="825.81"
					x2="509.73"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.73"
					y1="823.36"
					x2="467.69"
					y2="781.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="448.29"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="448.29"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="445.31"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="823.36"
					x2="445.31"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="833.27"
					x2="445.31"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="448.29"
					y1="833.27"
					x2="445.31"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="511.72"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="511.72"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="514.69"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="823.36"
					x2="514.69"
					y2="823.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="833.27"
					x2="514.69"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.72"
					y1="833.27"
					x2="514.69"
					y2="833.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="556.16"
					y1="896.43"
					x2="556.16"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="768.33"
					x2="733.1"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="733.1"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="768.33"
					x2="663.72"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="663.72"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="666.69"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="742.64"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="742.64"
					y1="768.33"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<polyline
					points="667.68 767.34 663.72 767.34 663.72 768.33 667.68 768.33 667.68 767.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="729.13 768.33 733.1 768.33 733.1 767.34 729.13 767.34 729.13 768.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="667.68 778.24 663.72 778.24 663.72 779.23 667.68 779.23 667.68 778.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="729.13 779.23 733.1 779.23 733.1 778.24 729.13 778.24 729.13 779.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.68"
					y1="767.34"
					x2="663.72"
					y2="767.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.72"
					y1="767.34"
					x2="663.72"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.72"
					y1="768.33"
					x2="667.68"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.68"
					y1="768.33"
					x2="667.68"
					y2="767.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.13"
					y1="768.33"
					x2="733.1"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.1"
					y1="768.33"
					x2="733.1"
					y2="767.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.1"
					y1="767.34"
					x2="729.13"
					y2="767.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.13"
					y1="767.34"
					x2="729.13"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.68"
					y1="778.24"
					x2="663.72"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.72"
					y1="778.24"
					x2="663.72"
					y2="779.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.72"
					y1="779.23"
					x2="667.68"
					y2="779.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.68"
					y1="779.23"
					x2="667.68"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.13"
					y1="779.23"
					x2="733.1"
					y2="779.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.1"
					y1="779.23"
					x2="733.1"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.1"
					y1="778.24"
					x2="729.13"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.13"
					y1="778.24"
					x2="729.13"
					y2="779.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="668.68 768.33 667.19 768.33 667.19 778.24 668.68 778.24 668.68 768.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="729.63 768.33 728.15 768.33 728.15 778.24 729.63 778.24 729.63 768.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="686.09 820.29 728.15 778.24 725.69 775.79 683.64 817.84 686.09 820.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.19"
					y1="778.24"
					x2="666.69"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.19"
					y1="768.33"
					x2="666.69"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="666.69"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.63"
					y1="778.24"
					x2="730.12"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.63"
					y1="768.33"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.68"
					y1="768.33"
					x2="668.68"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.68"
					y1="778.24"
					x2="667.19"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.19"
					y1="778.24"
					x2="667.19"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.19"
					y1="768.33"
					x2="668.68"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.63"
					y1="768.33"
					x2="729.63"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.63"
					y1="778.24"
					x2="728.15"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.15"
					y1="778.24"
					x2="728.15"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.15"
					y1="768.33"
					x2="729.63"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.09"
					y1="820.29"
					x2="683.64"
					y2="817.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.64"
					y1="817.84"
					x2="725.69"
					y2="775.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.69"
					y1="775.79"
					x2="728.15"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.15"
					y1="778.24"
					x2="686.09"
					y2="820.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="666.69"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="666.69"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="663.72"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="778.24"
					x2="663.72"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="768.33"
					x2="663.72"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="666.69"
					y1="768.33"
					x2="663.72"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="730.12"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="733.1"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="778.24"
					x2="733.1"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="768.33"
					x2="733.1"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="730.12"
					y1="768.33"
					x2="733.1"
					y2="768.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="621.02"
					y1="911.9"
					x2="621.02"
					y2="896.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="342.65"
					y1="631.54"
					x2="361.79"
					y2="631.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="367.09"
					x2="511.06"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.06"
					y1="303.66"
					x2="511.06"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="501.14"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="511.06"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<polyline
					points="512.05 304.65 512.05 300.69 511.06 300.69 511.06 304.65 512.05 304.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="501.14 304.65 501.14 300.69 500.15 300.69 500.15 304.65 501.14 304.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="512.05"
					y1="304.65"
					x2="512.05"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.05"
					y1="300.69"
					x2="511.06"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="300.69"
					x2="511.06"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="304.65"
					x2="512.05"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.05"
					y1="366.1"
					x2="511.06"
					y2="366.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="304.65"
					x2="501.14"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="300.69"
					x2="500.15"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.15"
					y1="300.69"
					x2="500.15"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.15"
					y1="304.65"
					x2="501.14"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="366.1"
					x2="500.15"
					y2="366.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="511.06 305.64 511.06 304.16 501.14 304.16 501.14 305.64 511.06 305.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="511.06 366.6 511.06 365.11 501.14 365.11 501.14 366.6 511.06 366.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.09 323.06 501.14 365.11 503.6 362.66 461.55 320.61 459.09 323.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="501.14"
					y1="304.16"
					x2="501.14"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="304.16"
					x2="511.06"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="511.06"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="366.6"
					x2="501.14"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="366.6"
					x2="511.06"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="367.09"
					x2="511.06"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="305.64"
					x2="501.14"
					y2="305.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="305.64"
					x2="501.14"
					y2="304.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="304.16"
					x2="511.06"
					y2="304.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="304.16"
					x2="511.06"
					y2="305.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="366.6"
					x2="501.14"
					y2="366.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="366.6"
					x2="501.14"
					y2="365.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="365.11"
					x2="511.06"
					y2="365.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.06"
					y1="365.11"
					x2="511.06"
					y2="366.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.09"
					y1="323.06"
					x2="461.55"
					y2="320.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.55"
					y1="320.61"
					x2="503.6"
					y2="362.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.6"
					y1="362.66"
					x2="501.14"
					y2="365.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="365.11"
					x2="459.09"
					y2="323.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="511.06"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="511.06"
					y2="303.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="501.14"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="303.66"
					x2="501.14"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.06"
					y1="303.66"
					x2="511.06"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="511.06"
					y1="303.66"
					x2="511.06"
					y2="300.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="367.09"
					x2="511.06"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="501.14"
					y1="367.09"
					x2="511.06"
					y2="367.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="387.31"
					x2="350.87"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="385.32"
					x2="353.35"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="350.87"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="353.35"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="387.31"
					x2="493.59"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="385.32"
					x2="491.11"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="493.59"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="491.11"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="342.65"
					y1="387.31"
					x2="353.35"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="342.65"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<polyline
					points="489.62 385.32 489.62 387.31 490.62 387.31 490.62 385.32 489.62 385.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="489.62 388.3 493.59 388.3 493.59 387.31 489.62 387.31 489.62 388.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="353.84 385.32 353.84 387.31 354.83 387.31 354.83 385.32 353.84 385.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="354.83 387.31 350.87 387.31 350.87 388.3 354.83 388.3 354.83 387.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="489.62 377.4 493.59 377.4 493.59 374.92 489.62 374.92 489.62 377.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="354.83 374.92 350.87 374.92 350.87 377.4 354.83 377.4 354.83 374.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="489.62"
					y1="385.32"
					x2="489.62"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.62"
					y1="387.31"
					x2="490.62"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.62"
					y1="387.31"
					x2="490.62"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.62"
					y1="385.32"
					x2="489.62"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.62"
					y1="388.3"
					x2="493.59"
					y2="388.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.59"
					y1="388.3"
					x2="493.59"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.59"
					y1="387.31"
					x2="489.62"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.62"
					y1="387.31"
					x2="489.62"
					y2="388.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="385.32"
					x2="353.84"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="387.31"
					x2="354.83"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="387.31"
					x2="354.83"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="385.32"
					x2="353.84"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="387.31"
					x2="350.87"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.87"
					y1="387.31"
					x2="350.87"
					y2="388.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.87"
					y1="388.3"
					x2="354.83"
					y2="388.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="388.3"
					x2="354.83"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.62"
					y1="377.4"
					x2="493.59"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.59"
					y1="377.4"
					x2="493.59"
					y2="374.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.59"
					y1="374.92"
					x2="489.62"
					y2="374.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.62"
					y1="374.92"
					x2="489.62"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="374.92"
					x2="350.87"
					y2="374.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.87"
					y1="374.92"
					x2="350.87"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.87"
					y1="377.4"
					x2="354.83"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.83"
					y1="377.4"
					x2="354.83"
					y2="374.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="486.65 385.32 490.62 385.32 490.62 377.4 486.65 377.4 486.65 385.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="353.84 385.32 357.81 385.32 357.81 377.4 353.84 377.4 353.84 385.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="424.21 377.4 357.81 377.4 357.81 380.87 424.21 380.87 424.21 377.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="462.86 380.87 396.46 380.87 396.46 384.33 462.86 384.33 462.86 380.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="490.62"
					y1="377.4"
					x2="491.11"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.62"
					y1="385.32"
					x2="491.11"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="491.11"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="377.4"
					x2="353.35"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="385.32"
					x2="353.35"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="353.35"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.65"
					y1="385.32"
					x2="486.65"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.65"
					y1="377.4"
					x2="490.62"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.62"
					y1="377.4"
					x2="490.62"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.62"
					y1="385.32"
					x2="486.65"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="385.32"
					x2="353.84"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="377.4"
					x2="357.81"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.81"
					y1="377.4"
					x2="357.81"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.81"
					y1="385.32"
					x2="353.84"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.21"
					y1="377.4"
					x2="424.21"
					y2="380.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.21"
					y1="380.87"
					x2="357.81"
					y2="380.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.81"
					y1="380.87"
					x2="357.81"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.81"
					y1="377.4"
					x2="424.21"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.86"
					y1="380.87"
					x2="462.86"
					y2="384.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.86"
					y1="384.33"
					x2="396.46"
					y2="384.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.46"
					y1="384.33"
					x2="396.46"
					y2="380.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.46"
					y1="380.87"
					x2="462.86"
					y2="380.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="491.11"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="491.11"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="385.32"
					x2="491.11"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="377.4"
					x2="493.59"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="385.32"
					x2="491.11"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="387.31"
					x2="493.59"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="491.11"
					y1="387.31"
					x2="493.59"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="353.35"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="353.35"
					y2="385.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="385.32"
					x2="353.35"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="377.4"
					x2="350.87"
					y2="377.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="385.32"
					x2="353.35"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="387.31"
					x2="350.87"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="353.35"
					y1="387.31"
					x2="350.87"
					y2="387.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="745.68"
					y1="173.06"
					x2="729.83"
					y2="173.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="729.83"
					y1="290.52"
					x2="745.68"
					y2="290.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="355.4"
					y1="65.86"
					x2="355.4"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".37"
				/>
				<line
					x1="556.16"
					y1="778.24"
					x2="556.16"
					y2="896.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.02"
					y1="778.24"
					x2="556.16"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.02"
					y1="896.43"
					x2="621.02"
					y2="778.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="563.84 889.03 612.49 889.03 612.49 786.15 563.84 786.15 563.84 889.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="563.84"
					y1="786.15"
					x2="563.84"
					y2="889.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.49"
					y1="786.15"
					x2="563.84"
					y2="786.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.49"
					y1="889.03"
					x2="612.49"
					y2="786.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.84"
					y1="889.03"
					x2="612.49"
					y2="889.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="588.59 878.92 588.15 878.96 587.73 879.06 587.33 879.22 586.97 879.45 586.66 879.72 586.41 880.05 586.23 880.4 586.11 880.79 586.07 881.18 586.11 881.57 586.23 881.95 586.41 882.31 586.66 882.63 586.97 882.91 587.33 883.13 587.73 883.3 588.15 883.4 588.59 883.43 589.03 883.4 589.45 883.3 589.85 883.13 590.21 882.91 590.52 882.63 590.77 882.31 590.95 881.95 591.07 881.57 591.1 881.18 591.07 880.79 590.95 880.4 590.77 880.05 590.52 879.72 590.21 879.45 589.85 879.22 589.45 879.06 589.03 878.96 588.59 878.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="589.03"
					y1="878.96"
					x2="588.59"
					y2="878.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.45"
					y1="879.06"
					x2="589.03"
					y2="878.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.85"
					y1="879.22"
					x2="589.45"
					y2="879.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.21"
					y1="879.45"
					x2="589.85"
					y2="879.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.52"
					y1="879.72"
					x2="590.21"
					y2="879.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.77"
					y1="880.05"
					x2="590.52"
					y2="879.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.95"
					y1="880.4"
					x2="590.77"
					y2="880.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.07"
					y1="880.79"
					x2="590.95"
					y2="880.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.1"
					y1="881.18"
					x2="591.07"
					y2="880.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.07"
					y1="881.57"
					x2="591.1"
					y2="881.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.95"
					y1="881.95"
					x2="591.07"
					y2="881.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.77"
					y1="882.31"
					x2="590.95"
					y2="881.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.52"
					y1="882.63"
					x2="590.77"
					y2="882.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.21"
					y1="882.91"
					x2="590.52"
					y2="882.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.85"
					y1="883.13"
					x2="590.21"
					y2="882.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.45"
					y1="883.3"
					x2="589.85"
					y2="883.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.03"
					y1="883.4"
					x2="589.45"
					y2="883.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.59"
					y1="883.43"
					x2="589.03"
					y2="883.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.15"
					y1="883.4"
					x2="588.59"
					y2="883.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="883.3"
					x2="588.15"
					y2="883.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.33"
					y1="883.13"
					x2="587.73"
					y2="883.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.97"
					y1="882.91"
					x2="587.33"
					y2="883.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.66"
					y1="882.63"
					x2="586.97"
					y2="882.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.41"
					y1="882.31"
					x2="586.66"
					y2="882.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.23"
					y1="881.95"
					x2="586.41"
					y2="882.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.11"
					y1="881.57"
					x2="586.23"
					y2="881.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.07"
					y1="881.18"
					x2="586.11"
					y2="881.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.11"
					y1="880.79"
					x2="586.07"
					y2="881.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.23"
					y1="880.4"
					x2="586.11"
					y2="880.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.41"
					y1="880.05"
					x2="586.23"
					y2="880.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.66"
					y1="879.72"
					x2="586.41"
					y2="880.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.97"
					y1="879.45"
					x2="586.66"
					y2="879.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.33"
					y1="879.22"
					x2="586.97"
					y2="879.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="879.06"
					x2="587.33"
					y2="879.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.15"
					y1="878.96"
					x2="587.73"
					y2="879.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.59"
					y1="878.92"
					x2="588.15"
					y2="878.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="590.76 891.67 590.73 892.01 590.63 892.34 590.47 892.64 590.25 892.92 589.98 893.16 589.67 893.36 589.33 893.5 588.97 893.59 588.59 893.62 588.21 893.59 587.85 893.5 587.5 893.36 587.19 893.16 586.93 892.92 586.71 892.64 586.55 892.34 586.45 892.01 586.42 891.67 586.77 888.4 586.82 888.15 586.91 887.89 587.05 887.66 587.63 883.54 587.66 883.4 587.72 883.26 587.81 883.13 587.92 883.02 588.04 882.92 588.19 882.85 588.34 882.81 588.51 882.78 588.67 882.78 588.83 882.81 588.99 882.85 589.13 882.92 589.26 883.02 589.37 883.13 589.46 883.26 589.52 883.4 589.55 883.54 590.13 887.66 590.27 887.89 590.36 888.15 590.41 888.4 590.76 891.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="590.76"
					y1="891.67"
					x2="590.41"
					y2="888.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.13"
					y1="887.66"
					x2="589.55"
					y2="883.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.63"
					y1="883.54"
					x2="587.05"
					y2="887.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.77"
					y1="888.4"
					x2="586.42"
					y2="891.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.41"
					y1="889.73"
					x2="587.41"
					y2="888.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.77"
					y1="888.57"
					x2="589.77"
					y2="889.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.77"
					y1="889.73"
					x2="587.41"
					y2="889.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m590.13,887.66c.16.22.26.47.28.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m587.63,883.54c.06-.43.47-.76.96-.76s.9.33.96.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m586.77,888.4c.03-.27.12-.52.28-.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m590.76,891.67c0,1.08-.97,1.95-2.17,1.95s-2.17-.87-2.17-1.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m587.41,888.57c0-.58.53-1.06,1.18-1.06s1.18.47,1.18,1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m587.05,887.66c.34-.47.91-.75,1.54-.75s1.2.28,1.54.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.72"
					y1="872.28"
					x2="621.02"
					y2="872.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.02"
					y1="872.28"
					x2="621.02"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.72"
					y1="872.28"
					x2="671.72"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.19"
					y1="881.69"
					x2="626.55"
					y2="881.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.55"
					y1="881.69"
					x2="626.55"
					y2="905.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.55"
					y1="905.47"
					x2="666.19"
					y2="905.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.19"
					y1="905.47"
					x2="666.19"
					y2="881.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.75"
					y1="880.12"
					x2="624.99"
					y2="880.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.99"
					y1="880.12"
					x2="624.99"
					y2="907.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.99"
					y1="907.04"
					x2="667.75"
					y2="907.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.75"
					y1="907.04"
					x2="667.75"
					y2="880.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m648.71,900.1c0-1.29-1.05-2.34-2.34-2.34s-2.34,1.05-2.34,2.34,1.05,2.34,2.34,2.34,2.34-1.05,2.34-2.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="648.32 909.77 648.01 906.49 647.76 905.75 647.24 901.62 646.95 901.07 646.37 900.85 645.79 901.07 645.51 901.62 644.99 905.75 644.73 906.49 644.42 909.77 644.99 911.15 646.37 911.72 647.75 911.15 648.32 909.77"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m648.32,909.77c0,1.08-.87,1.95-1.95,1.95s-1.95-.87-1.95-1.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.73"
					y1="906.49"
					x2="644.42"
					y2="909.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m644.73,906.49c.02-.27.11-.52.25-.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.51"
					y1="901.62"
					x2="644.99"
					y2="905.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m645.51,901.62c.05-.44.43-.77.87-.77s.81.33.87.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.76"
					y1="905.75"
					x2="647.24"
					y2="901.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m647.76,905.75c.15.22.23.48.26.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.32"
					y1="909.77"
					x2="648.01"
					y2="906.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.31"
					y1="907.82"
					x2="645.31"
					y2="906.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.43"
					y1="906.66"
					x2="647.43"
					y2="907.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.43"
					y1="907.82"
					x2="645.31"
					y2="907.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m645.31,906.66c0-.59.48-1.06,1.06-1.06s1.06.48,1.06,1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m644.99,905.75c.3-.47.83-.75,1.39-.75s1.08.28,1.38.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="704.59 859.85 702.26 861.85 700.49 864.37 698.24 870.27 697.45 875.18 697.76 880.15 699.14 884.94 699.03 889.25 697.94 893.42 695.91 897.24 693.83 901.14 693.42 903.61 693.42 904.09 694.7 908 697.69 910.83 701.66 911.9 722.26 911.9 725.33 911.27 728.02 909.65 728.02 911.4 729.62 911.4 729.62 907.56 730.19 906.11 730.38 902.45 729.12 899 728.06 897.33 726.02 893.47 724.92 889.25 724.8 884.89 726.17 880.12 726.47 875.17 725.68 870.27 723.43 864.37 721.66 861.85 719.33 859.85 715.8 858.27 711.96 857.72 708.13 858.27 704.59 859.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="719.3"
					y1="893.6"
					x2="704.62"
					y2="893.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.66"
					y1="911.9"
					x2="711.96"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.66"
					y1="911.17"
					x2="711.96"
					y2="911.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.26"
					y1="911.9"
					x2="711.96"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.26"
					y1="911.17"
					x2="711.96"
					y2="911.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.01"
					y1="893.6"
					x2="705.01"
					y2="896.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.01"
					y1="896.35"
					x2="707.27"
					y2="896.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.27"
					y1="896.35"
					x2="707.27"
					y2="893.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.92"
					y1="893.6"
					x2="718.92"
					y2="896.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.92"
					y1="896.35"
					x2="716.65"
					y2="896.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.65"
					y1="896.35"
					x2="716.65"
					y2="893.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.02"
					y1="904.59"
					x2="728.02"
					y2="911.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.62"
					y1="904.59"
					x2="729.62"
					y2="911.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.62"
					y1="911.4"
					x2="728.02"
					y2="911.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.62"
					y1="904.59"
					x2="728.02"
					y2="904.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.96"
					y1="857.72"
					x2="709.5"
					y2="858.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.5"
					y1="858.01"
					x2="707.12"
					y2="858.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.12"
					y1="858.64"
					x2="704.59"
					y2="859.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.59"
					y1="859.85"
					x2="702.26"
					y2="861.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.26"
					y1="861.85"
					x2="700.49"
					y2="864.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.49"
					y1="864.37"
					x2="699.19"
					y2="867.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.19"
					y1="867.23"
					x2="698.24"
					y2="870.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.24"
					y1="870.27"
					x2="697.39"
					y2="875.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.39"
					y1="875.18"
					x2="697.34"
					y2="877.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.34"
					y1="877.65"
					x2="697.62"
					y2="880.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.62"
					y1="880.12"
					x2="698.74"
					y2="883.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.74"
					y1="883.94"
					x2="700.47"
					y2="887.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.47"
					y1="887.65"
					x2="702.53"
					y2="890.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.53"
					y1="890.96"
					x2="704.62"
					y2="893.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.14"
					y1="884.94"
					x2="699.12"
					y2="888.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.12"
					y1="888.37"
					x2="698.55"
					y2="891.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.55"
					y1="891.72"
					x2="697.13"
					y2="895.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.13"
					y1="895.3"
					x2="694.02"
					y2="900.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.02"
					y1="900.58"
					x2="693.43"
					y2="903.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.43"
					y1="903.21"
					x2="693.65"
					y2="905.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.65"
					y1="905.82"
					x2="694.67"
					y2="908.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.67"
					y1="908.2"
					x2="696.47"
					y2="910.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.47"
					y1="910.11"
					x2="698.23"
					y2="911.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.23"
					y1="911.09"
					x2="699.91"
					y2="911.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.91"
					y1="911.62"
					x2="701.66"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.66"
					y1="911.17"
					x2="699.26"
					y2="910.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.26"
					y1="910.59"
					x2="697.83"
					y2="909.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.83"
					y1="909.38"
					x2="696.93"
					y2="907.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.93"
					y1="907.7"
					x2="696.51"
					y2="905.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.51"
					y1="905.49"
					x2="696.41"
					y2="903.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.41"
					y1="903.22"
					x2="696.42"
					y2="902.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.42"
					y1="902.08"
					x2="696.9"
					y2="901.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.9"
					y1="901.18"
					x2="697.46"
					y2="900.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.46"
					y1="900.92"
					x2="703.69"
					y2="899.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.69"
					y1="899.15"
					x2="709.92"
					y2="898.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="898.4"
					x2="711.96"
					y2="898.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.8"
					y1="884.89"
					x2="724.83"
					y2="888.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.83"
					y1="888.33"
					x2="725.39"
					y2="891.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.39"
					y1="891.69"
					x2="726.79"
					y2="895.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.79"
					y1="895.3"
					x2="729.9"
					y2="900.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.9"
					y1="900.58"
					x2="730.39"
					y2="902.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.39"
					y1="902.33"
					x2="730.5"
					y2="904.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.5"
					y1="904.14"
					x2="730.25"
					y2="905.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.25"
					y1="905.9"
					x2="729.62"
					y2="907.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.26"
					y1="911.17"
					x2="724.66"
					y2="910.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.66"
					y1="910.59"
					x2="726.09"
					y2="909.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.09"
					y1="909.38"
					x2="726.99"
					y2="907.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.99"
					y1="907.7"
					x2="727.41"
					y2="905.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.41"
					y1="905.49"
					x2="727.51"
					y2="903.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.51"
					y1="903.22"
					x2="727.5"
					y2="902.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.5"
					y1="902.08"
					x2="727.02"
					y2="901.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.02"
					y1="901.18"
					x2="726.46"
					y2="900.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.46"
					y1="900.92"
					x2="720.24"
					y2="899.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.24"
					y1="899.15"
					x2="714.01"
					y2="898.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.01"
					y1="898.4"
					x2="711.96"
					y2="898.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.96"
					y1="857.72"
					x2="714.42"
					y2="858.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.42"
					y1="858.01"
					x2="716.8"
					y2="858.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.8"
					y1="858.64"
					x2="719.33"
					y2="859.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.33"
					y1="859.85"
					x2="721.67"
					y2="861.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.67"
					y1="861.85"
					x2="723.43"
					y2="864.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.43"
					y1="864.37"
					x2="724.73"
					y2="867.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.73"
					y1="867.23"
					x2="725.68"
					y2="870.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.68"
					y1="870.27"
					x2="726.53"
					y2="875.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.53"
					y1="875.18"
					x2="726.58"
					y2="877.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.58"
					y1="877.65"
					x2="726.3"
					y2="880.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.3"
					y1="880.12"
					x2="725.19"
					y2="883.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.19"
					y1="883.94"
					x2="723.45"
					y2="887.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.45"
					y1="887.65"
					x2="721.39"
					y2="890.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.39"
					y1="890.96"
					x2="719.3"
					y2="893.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.71"
					y1="899.16"
					x2="695.1"
					y2="898.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.1"
					y1="898.6"
					x2="696.23"
					y2="897.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.23"
					y1="897.76"
					x2="697.22"
					y2="897.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.22"
					y1="897.57"
					x2="709.89"
					y2="896.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.89"
					y1="896.78"
					x2="711.96"
					y2="896.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.22"
					y1="899.16"
					x2="728.82"
					y2="898.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.82"
					y1="898.6"
					x2="727.69"
					y2="897.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.69"
					y1="897.76"
					x2="726.7"
					y2="897.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.7"
					y1="897.57"
					x2="714.04"
					y2="896.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.04"
					y1="896.78"
					x2="711.96"
					y2="896.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.02"
					y1="909.65"
					x2="727.45"
					y2="910.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.45"
					y1="910.11"
					x2="725.69"
					y2="911.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.69"
					y1="911.09"
					x2="724.01"
					y2="911.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.01"
					y1="911.62"
					x2="722.26"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="688.17 911.9 688.17 911.11 692.14 911.11 692.14 911.9 688.17 911.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="688.17"
					y1="911.9"
					x2="688.17"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.17"
					y1="911.11"
					x2="692.14"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.14"
					y1="911.11"
					x2="692.14"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.14"
					y1="911.9"
					x2="688.17"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="735.75 911.9 731.78 911.9 731.78 911.11 735.75 911.11 735.75 911.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="735.75"
					y1="911.9"
					x2="731.78"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.78"
					y1="911.9"
					x2="731.78"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.78"
					y1="911.11"
					x2="735.75"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.75"
					y1="911.11"
					x2="735.75"
					y2="911.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="689.76 911.11 689.76 904.66 690.55 904.66 690.55 911.11 689.76 911.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="689.76"
					y1="911.11"
					x2="689.76"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.76"
					y1="904.66"
					x2="690.55"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.55"
					y1="904.66"
					x2="690.55"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.55"
					y1="911.11"
					x2="689.76"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="734.16 911.11 733.37 911.11 733.37 904.66 734.16 904.66 734.16 911.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="734.16"
					y1="911.11"
					x2="733.37"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.37"
					y1="911.11"
					x2="733.37"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.37"
					y1="904.66"
					x2="734.16"
					y2="904.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.16"
					y1="904.66"
					x2="734.16"
					y2="911.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="690.55 906.64 690.55 905.06 733.37 905.06 733.37 906.64 690.55 906.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="690.55"
					y1="906.64"
					x2="690.55"
					y2="905.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.55"
					y1="905.06"
					x2="733.37"
					y2="905.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.37"
					y1="905.06"
					x2="733.37"
					y2="906.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.37"
					y1="906.64"
					x2="690.55"
					y2="906.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="419.06 698.47 419.06 631.54 342.65 631.54 342.65 698.47 419.06 698.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="342.65"
					y1="698.47"
					x2="419.06"
					y2="698.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.65"
					y1="631.54"
					x2="342.65"
					y2="698.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.06"
					y1="631.54"
					x2="342.65"
					y2="631.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.06"
					y1="698.47"
					x2="419.06"
					y2="631.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.1"
					y1="698.47"
					x2="414.1"
					y2="631.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="409.36 489.67 364.13 489.67 364.13 445.22 409.36 445.22 409.36 489.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="409.36"
					y1="489.67"
					x2="407.2"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.35"
					y1="489.67"
					x2="399.59"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.74"
					y1="489.67"
					x2="391.98"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.12"
					y1="489.67"
					x2="384.37"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.52"
					y1="489.67"
					x2="376.76"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.9"
					y1="489.67"
					x2="369.14"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.29"
					y1="489.67"
					x2="364.13"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="489.67"
					x2="364.13"
					y2="487.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="485.05"
					x2="364.13"
					y2="480.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="477.44"
					x2="364.13"
					y2="472.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="469.83"
					x2="364.13"
					y2="465.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="462.21"
					x2="364.13"
					y2="457.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="454.6"
					x2="364.13"
					y2="449.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="446.99"
					x2="364.13"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="445.22"
					x2="366.29"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.14"
					y1="445.22"
					x2="373.9"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.76"
					y1="445.22"
					x2="381.52"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.37"
					y1="445.22"
					x2="389.12"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.98"
					y1="445.22"
					x2="396.74"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.59"
					y1="445.22"
					x2="404.35"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.2"
					y1="445.22"
					x2="409.36"
					y2="445.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="445.22"
					x2="409.36"
					y2="446.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="449.84"
					x2="409.36"
					y2="454.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="457.45"
					x2="409.36"
					y2="462.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="465.07"
					x2="409.36"
					y2="469.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="472.68"
					x2="409.36"
					y2="477.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="480.29"
					x2="409.36"
					y2="485.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="487.9"
					x2="409.36"
					y2="489.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="411.7 445.39 413.07 445.39 413.07 489.5 411.7 489.5 411.7 482.58 412.82 482.58 412.82 452.31 411.7 452.31 411.7 445.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="411.7"
					y1="445.39"
					x2="413.07"
					y2="445.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="413.07"
					y1="445.39"
					x2="413.07"
					y2="489.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="413.07"
					y1="489.5"
					x2="411.7"
					y2="489.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="411.7"
					y1="489.5"
					x2="411.7"
					y2="482.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="411.7"
					y1="482.58"
					x2="412.82"
					y2="482.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="412.82"
					y1="482.58"
					x2="412.82"
					y2="452.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="412.82"
					y1="452.31"
					x2="411.7"
					y2="452.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="411.7"
					y1="452.31"
					x2="411.7"
					y2="445.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<polyline
					points="411.7 443.66 411.7 491.23 409.36 491.23 409.36 443.66 411.7 443.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="411.7"
					y1="443.66"
					x2="411.7"
					y2="491.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="411.7"
					y1="491.23"
					x2="409.36"
					y2="491.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="409.36"
					y1="491.23"
					x2="409.36"
					y2="443.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="409.36"
					y1="443.66"
					x2="411.7"
					y2="443.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="411.7"
					y1="489.5"
					x2="413.07"
					y2="489.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.07"
					y1="489.5"
					x2="413.07"
					y2="445.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.07"
					y1="445.39"
					x2="411.7"
					y2="445.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.7"
					y1="491.23"
					x2="411.7"
					y2="443.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.7"
					y1="452.31"
					x2="412.82"
					y2="452.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.82"
					y1="452.31"
					x2="412.82"
					y2="482.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.82"
					y1="482.58"
					x2="411.7"
					y2="482.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="491.23"
					x2="411.7"
					y2="491.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.7"
					y1="443.66"
					x2="409.36"
					y2="443.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="443.66"
					x2="409.36"
					y2="491.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="413.33 552.16 361.79 552.16 361.79 611.63 413.33 611.63 413.33 552.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="413.33"
					y1="552.16"
					x2="413.33"
					y2="611.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.79"
					y1="552.16"
					x2="361.79"
					y2="611.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.35"
					y1="552.16"
					x2="363.35"
					y2="611.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.33"
					y1="552.16"
					x2="361.79"
					y2="552.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.33"
					y1="611.63"
					x2="361.79"
					y2="611.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.99"
					y1="556.06"
					x2="410.99"
					y2="607.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.99"
					y1="607.72"
					x2="409.43"
					y2="609.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.43"
					y1="609.28"
					x2="365.69"
					y2="609.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.69"
					y1="609.28"
					x2="364.13"
					y2="607.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="607.72"
					x2="364.13"
					y2="556.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.13"
					y1="556.06"
					x2="365.69"
					y2="554.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.69"
					y1="554.5"
					x2="409.43"
					y2="554.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.43"
					y1="554.5"
					x2="410.99"
					y2="556.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m408.25,567.03c0-4.31-3.5-7.8-7.8-7.8s-7.8,3.49-7.8,7.8,3.5,7.8,7.8,7.8,7.8-3.5,7.8-7.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m380.53,567.03c0-3.23-2.62-5.85-5.85-5.85s-5.85,2.62-5.85,5.85,2.62,5.85,5.85,5.85,5.85-2.62,5.85-5.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m406.29,596.76c0-3.23-2.62-5.86-5.85-5.86s-5.85,2.62-5.85,5.86,2.62,5.85,5.85,5.85,5.85-2.62,5.85-5.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m382.48,596.76c0-4.31-3.5-7.8-7.8-7.8s-7.8,3.49-7.8,7.8,3.5,7.8,7.8,7.8,7.8-3.5,7.8-7.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="403.67 497.72 403.67 547.09 403.21 548.19 402.1 548.65 369.05 548.65 367.95 548.19 367.49 547.09 367.49 497.72 367.95 496.61 369.05 496.16 402.1 496.16 403.21 496.61 403.67 497.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="403.67"
					y1="497.72"
					x2="403.67"
					y2="547.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m403.67,547.09c0,.86-.7,1.56-1.56,1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.1"
					y1="548.65"
					x2="369.05"
					y2="548.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m369.05,548.65c-.86,0-1.56-.7-1.56-1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.49"
					y1="547.09"
					x2="367.49"
					y2="497.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m367.49,497.72c0-.86.7-1.56,1.56-1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.05"
					y1="496.16"
					x2="402.1"
					y2="496.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m402.1,496.16c.86,0,1.56.7,1.56,1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.76"
					y1="501.62"
					x2="399.76"
					y2="543.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.2"
					y1="544.75"
					x2="376.85"
					y2="544.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.29"
					y1="543.19"
					x2="375.29"
					y2="501.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.85"
					y1="500.06"
					x2="398.2"
					y2="500.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.76"
					y1="501.62"
					x2="399.76"
					y2="501.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m399.76,543.19c0,.86-.7,1.56-1.56,1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m376.85,544.75c-.86,0-1.56-.7-1.56-1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m375.29,501.62c0-.86.7-1.56,1.56-1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m398.2,500.06c.86,0,1.56.7,1.56,1.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m385.44,522.4c0-1.3-1.05-2.34-2.34-2.34s-2.34,1.05-2.34,2.34,1.05,2.34,2.34,2.34,2.34-1.05,2.34-2.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="385.27 521.7 385.77 521.91 385.97 522.4 385.76 522.9 385.27 523.11 369.83 523.11 369.33 522.9 369.13 522.4 369.33 521.91 369.83 521.7 385.27 521.7"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m385.27,521.7c.39,0,.7.32.7.71s-.31.7-.7.7h0"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.27"
					y1="523.11"
					x2="369.83"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m369.83,523.11c-.39,0-.7-.32-.7-.7s.31-.71.7-.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.83"
					y1="521.7"
					x2="385.27"
					y2="521.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.81 520.84 373.81 521.7 369.83 521.7 369.33 521.91 369.13 522.4 369.33 522.9 369.83 523.11 373.81 523.11 373.81 523.96 368.74 523.96 368.74 520.84 373.81 520.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="373.81"
					y1="520.84"
					x2="373.81"
					y2="521.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.81"
					y1="521.7"
					x2="369.83"
					y2="521.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m369.83,523.11c-.39,0-.7-.32-.7-.7s.31-.71.7-.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.83"
					y1="523.11"
					x2="373.81"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.81"
					y1="523.11"
					x2="373.81"
					y2="523.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.81"
					y1="523.96"
					x2="368.74"
					y2="523.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.74"
					y1="523.96"
					x2="368.74"
					y2="520.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.74"
					y1="520.84"
					x2="373.81"
					y2="520.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="376.62 520.87 376.62 521.7 373.89 521.7 373.89 520.87 376.62 520.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="376.62"
					y1="520.87"
					x2="376.62"
					y2="521.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.62"
					y1="521.7"
					x2="373.89"
					y2="521.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.89"
					y1="521.7"
					x2="373.89"
					y2="520.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.89"
					y1="520.87"
					x2="376.62"
					y2="520.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="376.62 523.94 373.89 523.94 373.89 523.11 376.62 523.11 376.62 523.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="376.62"
					y1="523.94"
					x2="373.89"
					y2="523.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.89"
					y1="523.94"
					x2="373.89"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.89"
					y1="523.11"
					x2="376.62"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.62"
					y1="523.11"
					x2="376.62"
					y2="523.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.83"
					y1="856.52"
					x2="498.83"
					y2="842.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.83"
					y1="842.64"
					x2="461.17"
					y2="842.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.76"
					y1="856.52"
					x2="453.24"
					y2="856.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.24"
					y1="892.2"
					x2="506.76"
					y2="892.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.76"
					y1="892.2"
					x2="506.76"
					y2="838.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.24"
					y1="838.68"
					x2="453.24"
					y2="892.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.76"
					y1="839.67"
					x2="453.24"
					y2="839.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.17"
					y1="856.52"
					x2="461.17"
					y2="842.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.76"
					y1="838.68"
					x2="453.24"
					y2="838.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.06"
					y1="633.52"
					x2="422.97"
					y2="633.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.97"
					y1="633.52"
					x2="422.97"
					y2="635.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.97"
					y1="635.5"
					x2="419.06"
					y2="635.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="698.47"
					x2="409.36"
					y2="696.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="694.03"
					x2="409.36"
					y2="689.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="686.41"
					x2="409.36"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="678.8"
					x2="409.36"
					y2="674.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="671.19"
					x2="409.36"
					y2="666.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="663.58"
					x2="409.36"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="655.97"
					x2="409.36"
					y2="651.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="648.36"
					x2="409.36"
					y2="643.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="640.74"
					x2="409.36"
					y2="635.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="633.13"
					x2="409.36"
					y2="631.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="631.54"
					x2="385.58"
					y2="630.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="627.41"
					x2="385.58"
					y2="622.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="619.8"
					x2="385.58"
					y2="615.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="612.18"
					x2="385.58"
					y2="607.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="604.57"
					x2="385.58"
					y2="599.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="596.96"
					x2="385.58"
					y2="592.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="589.35"
					x2="385.58"
					y2="584.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="581.73"
					x2="385.58"
					y2="576.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="574.12"
					x2="385.58"
					y2="569.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="566.51"
					x2="385.58"
					y2="561.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="558.9"
					x2="385.58"
					y2="554.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="551.29"
					x2="385.58"
					y2="546.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="543.68"
					x2="385.58"
					y2="538.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="536.06"
					x2="385.58"
					y2="531.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="528.45"
					x2="385.58"
					y2="523.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="520.84"
					x2="385.58"
					y2="516.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="513.23"
					x2="385.58"
					y2="508.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="505.62"
					x2="385.58"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="498.01"
					x2="385.58"
					y2="493.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="490.39"
					x2="385.58"
					y2="485.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="482.78"
					x2="385.58"
					y2="478.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="475.17"
					x2="385.58"
					y2="470.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="467.56"
					x2="385.58"
					y2="462.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="459.95"
					x2="385.58"
					y2="455.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="452.34"
					x2="385.58"
					y2="447.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.58"
					y1="444.92"
					x2="385.58"
					y2="443.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="631.54"
					x2="409.36"
					y2="611.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.36"
					y1="552.16"
					x2="409.36"
					y2="443.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.37"
					y1="65.86"
					x2="497.18"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.14"
					y1="50"
					x2="355.4"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.83"
					y1="446.47"
					x2="729.83"
					y2="292.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.68"
					y1="290.52"
					x2="745.68"
					y2="447.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m624.03,65.86c57.77,2.82,103.75,49.41,105.8,107.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m624.03,50c67.39.69,121.66,55.51,121.66,122.9v.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.83"
					y1="886.25"
					x2="461.17"
					y2="886.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.17"
					y1="886.25"
					x2="461.17"
					y2="860.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.17"
					y1="860.48"
					x2="498.83"
					y2="860.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.83"
					y1="860.48"
					x2="498.83"
					y2="886.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="729.83 169.1 741.72 169.1 741.72 173.06 729.83 173.06 729.83 169.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="729.83"
					y1="169.1"
					x2="729.83"
					y2="173.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.83"
					y1="173.06"
					x2="741.72"
					y2="173.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="173.06"
					x2="741.72"
					y2="169.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.72"
					y1="169.1"
					x2="729.83"
					y2="169.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="624.03 65.86 624.03 53.96 627.99 53.96 627.99 65.86 624.03 65.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="624.03"
					y1="65.86"
					x2="627.99"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.99"
					y1="65.86"
					x2="627.99"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.99"
					y1="53.96"
					x2="624.03"
					y2="53.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.03"
					y1="53.96"
					x2="624.03"
					y2="65.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="624.02 50 624.02 65.86 511.05 65.86 511.05 303.66 501.14 303.66 501.14 50 624.02 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
				<polygon
					points="758.5 578.71 758.5 950 423.21 950 423.21 839.21 418.2 839.21 418.2 823.36 448.29 823.36 448.29 833.27 439.08 833.27 439.08 934.14 520.93 934.14 520.93 833.27 511.72 833.27 511.72 823.36 546.24 823.36 546.24 768.34 666.7 768.34 666.7 778.24 556.16 778.24 556.16 896.43 621.02 896.43 621.02 911.9 742.65 911.9 742.65 778.24 730.12 778.24 730.12 768.34 742.65 768.34 742.65 662.25 677.83 662.25 677.83 611.67 742.65 611.67 742.65 594.56 729.83 594.56 729.83 447.79 745.68 447.79 745.68 578.71 758.5 578.71"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
				<rect
					x="729.83"
					y="173.06"
					width="15.85"
					height="117.47"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
				<polygon
					points="511.05 367.09 511.05 443.45 361.79 443.45 361.79 631.54 342.66 631.54 342.66 823.36 354.77 823.36 354.77 839.21 326.79 839.21 326.79 347.55 241.5 347.55 241.5 50 355.4 50 355.4 65.86 257.35 65.86 257.35 331.68 342.66 331.68 342.66 377.39 353.34 377.39 353.34 387.31 342.66 387.31 342.66 433.54 501.14 433.54 501.14 387.31 491.11 387.31 491.11 377.39 501.14 377.39 501.14 367.09 511.05 367.09"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.13"
				/>
			</g>
			<g id="text">
				<path d="m377.95,670.51h-1.29l-1.55-2.6c-.14-.24-.28-.45-.41-.61-.13-.17-.27-.31-.41-.42-.14-.11-.29-.19-.45-.23-.16-.05-.34-.08-.54-.08h-.89v3.94h-1.08v-9.26h2.76c.4,0,.78.05,1.12.16.34.1.64.25.89.46.25.21.45.47.59.77.14.31.21.67.21,1.08,0,.32-.05.62-.15.89-.09.27-.23.51-.41.72-.18.21-.39.39-.65.54-.25.15-.53.26-.85.34v.03c.15.07.29.15.4.24.12.09.23.19.33.31.1.12.2.26.3.41.1.15.22.33.34.53l1.74,2.78Zm-5.55-8.28v3.36h1.47c.27,0,.52-.04.75-.12.23-.08.43-.2.6-.35.17-.16.3-.34.39-.56.09-.22.14-.47.14-.75,0-.5-.16-.88-.48-1.16-.32-.28-.78-.42-1.39-.42h-1.49Zm11.87,5.24h-4.67c.02.74.22,1.3.59,1.7.38.4.9.6,1.56.6.74,0,1.43-.25,2.05-.74v.99c-.58.42-1.35.63-2.31.63s-1.67-.3-2.2-.9c-.53-.6-.8-1.45-.8-2.54,0-1.03.29-1.87.87-2.51.59-.65,1.31-.98,2.18-.98s1.53.28,2.01.84c.47.56.71,1.34.71,2.33v.56Zm-1.09-.9c0-.61-.15-1.09-.45-1.43-.29-.34-.69-.51-1.21-.51s-.92.18-1.27.54c-.35.36-.56.82-.65,1.4h3.57Zm5.83-4.92c-.21-.12-.44-.17-.7-.17-.74,0-1.11.47-1.11,1.4v1.02h1.55v.9h-1.55v5.71h-1.05v-5.71h-1.13v-.9h1.13v-1.07c0-.69.2-1.24.6-1.64.4-.4.9-.61,1.5-.61.32,0,.58.04.77.12v.96Z" />
				<path d="m390.14,670.66c-.2,0-.37-.07-.51-.21-.14-.14-.21-.31-.21-.51s.07-.37.21-.51c.14-.15.31-.22.51-.22s.37.07.52.22c.14.14.21.31.21.51s-.07.37-.21.51c-.14.14-.31.21-.52.21Z" />
				<path d="m365.18,471.59v-9.19h3.17c.71,0,1.26.04,1.64.13.53.12.98.34,1.35.66.48.41.85.93,1.08,1.57.24.64.36,1.36.36,2.18,0,.7-.08,1.32-.24,1.86-.16.54-.37.99-.63,1.34-.26.35-.54.63-.84.83-.3.2-.67.35-1.1.46-.43.1-.92.16-1.47.16h-3.32Zm1.22-1.08h1.96c.61,0,1.08-.06,1.42-.17.35-.11.62-.27.83-.48.29-.29.51-.68.67-1.16.16-.49.24-1.08.24-1.77,0-.96-.16-1.7-.48-2.21-.31-.52-.7-.87-1.15-1.04-.33-.13-.85-.19-1.57-.19h-1.93v7.02Zm9.67,1.08l-2.44-9.19h1.25l1.4,6.03c.15.63.28,1.26.39,1.88.23-.98.37-1.55.41-1.7l1.75-6.21h1.47l1.32,4.65c.33,1.15.57,2.24.72,3.25.12-.58.27-1.25.46-2l1.44-5.91h1.22l-2.52,9.19h-1.17l-1.94-7.01c-.16-.59-.26-.94-.29-1.08-.1.42-.19.78-.27,1.08l-1.95,7.01h-1.24Z" />
				<path d="m539.96,337.37h-7.46v-14.37h1.68v12.85h5.77v1.52Zm2.82-12.87c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.87h-1.64v-10.26h1.64v10.26Zm11.38-10.26l-4.09,10.26h-1.61l-3.89-10.26h1.8l2.61,7.46c.19.55.31,1.03.36,1.43h.04c.07-.51.17-.98.32-1.39l2.73-7.5h1.73Zm2.6-2.61c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.87h-1.64v-10.26h1.64v10.26Zm11.83,0h-1.64v-5.85c0-2.18-.79-3.27-2.38-3.27-.82,0-1.5.31-2.04.93-.53.61-.8,1.39-.8,2.33v5.85h-1.64v-10.26h1.64v1.7h.04c.77-1.3,1.9-1.94,3.37-1.94,1.12,0,1.98.36,2.58,1.09.59.72.89,1.77.89,3.14v6.27Zm11.85-.82c0,3.77-1.8,5.65-5.41,5.65-1.27,0-2.38-.24-3.33-.72v-1.64c1.16.64,2.26.96,3.31.96,2.53,0,3.79-1.34,3.79-4.03v-1.12h-.04c-.78,1.31-1.96,1.96-3.53,1.96-1.28,0-2.3-.45-3.09-1.36-.77-.92-1.16-2.14-1.16-3.68,0-1.74.42-3.13,1.25-4.16.84-1.03,1.99-1.54,3.45-1.54s2.41.55,3.08,1.66h.04v-1.42h1.64v9.44Zm-1.64-3.82v-1.51c0-.82-.28-1.51-.83-2.09-.55-.58-1.23-.87-2.05-.87-1.02,0-1.81.37-2.38,1.11-.57.73-.86,1.77-.86,3.1,0,1.14.27,2.06.82,2.75.55.68,1.29,1.02,2.19,1.02s1.67-.33,2.24-.98c.58-.65.87-1.49.87-2.52Z" />
				<polygon points="591.85 323 584.96 339.75 583.43 339.75 590.3 323 591.85 323" />
				<path d="m593.53,337.37v-14.37h3.97c5.06,0,7.6,2.33,7.6,7,0,2.22-.7,4-2.11,5.35-1.4,1.34-3.28,2.01-5.64,2.01h-3.81Zm1.68-12.85v11.32h2.14c1.88,0,3.35-.5,4.4-1.51,1.05-1.01,1.57-2.44,1.57-4.29,0-3.68-1.96-5.52-5.87-5.52h-2.24Zm13.26-.02c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.87h-1.64v-10.26h1.64v10.26Zm11.78,0h-1.64v-5.85c0-2.18-.79-3.27-2.38-3.27-.82,0-1.5.31-2.04.93-.53.61-.8,1.39-.8,2.33v5.85h-1.64v-10.26h1.64v1.7h.04c.77-1.3,1.9-1.94,3.37-1.94,1.12,0,1.98.36,2.58,1.09.59.72.89,1.77.89,3.14v6.27Zm3.88-12.87c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.87h-1.64v-10.26h1.64v10.26Zm11.78,0h-1.64v-5.85c0-2.18-.79-3.27-2.38-3.27-.82,0-1.5.31-2.04.93-.53.61-.8,1.39-.8,2.33v5.85h-1.64v-10.26h1.64v1.7h.04c.77-1.3,1.9-1.94,3.37-1.94,1.12,0,1.98.36,2.58,1.09.59.72.89,1.77.89,3.14v6.27Zm11.79-.82c0,3.77-1.8,5.65-5.41,5.65-1.27,0-2.38-.24-3.33-.72v-1.64c1.16.64,2.26.96,3.31.96,2.53,0,3.79-1.34,3.79-4.03v-1.12h-.04c-.78,1.31-1.96,1.96-3.53,1.96-1.28,0-2.3-.45-3.09-1.36-.77-.92-1.16-2.14-1.16-3.68,0-1.74.42-3.13,1.25-4.16.84-1.03,1.99-1.54,3.45-1.54s2.41.55,3.08,1.66h.04v-1.42h1.64v9.44Zm-1.64-3.82v-1.51c0-.81-.28-1.51-.83-2.09-.55-.58-1.23-.87-2.05-.87-1.02,0-1.81.37-2.38,1.11-.57.73-.86,1.77-.86,3.1,0,1.14.27,2.06.82,2.75.55.68,1.29,1.02,2.19,1.02s1.67-.33,2.24-.98c.58-.65.87-1.49.87-2.52Z" />
				<path d="m668.95,337.37h-2l-2.4-4.03c-.22-.37-.43-.69-.64-.95-.21-.27-.42-.48-.64-.65-.21-.17-.45-.29-.7-.36-.25-.08-.53-.12-.84-.12h-1.38v6.11h-1.68v-14.37h4.29c.63,0,1.21.08,1.73.24.53.15,1,.39,1.38.71.39.32.7.72.92,1.2.22.47.33,1.03.33,1.67,0,.5-.08.96-.23,1.38-.15.41-.36.78-.64,1.11-.27.33-.61.61-1,.84-.39.23-.82.4-1.31.53v.04c.24.11.45.23.62.37.18.13.35.29.51.48.16.19.32.4.47.64.16.23.34.51.53.82l2.7,4.32Zm-8.62-12.85v5.21h2.28c.42,0,.81-.06,1.16-.19.36-.13.67-.31.93-.54.26-.24.46-.53.61-.87.15-.35.22-.73.22-1.16,0-.77-.25-1.37-.75-1.79-.49-.43-1.21-.65-2.15-.65h-2.3Zm14.59,13.09c-1.52,0-2.73-.48-3.64-1.43-.9-.96-1.35-2.23-1.35-3.82,0-1.72.47-3.07,1.41-4.04.94-.97,2.21-1.45,3.82-1.45s2.72.47,3.58,1.41c.86.94,1.29,2.25,1.29,3.92s-.46,2.95-1.39,3.94c-.92.98-2.16,1.47-3.72,1.47Zm.12-9.36c-1.06,0-1.89.36-2.51,1.08-.61.71-.92,1.7-.92,2.97s.31,2.17.93,2.88c.62.7,1.45,1.05,2.5,1.05s1.88-.34,2.45-1.03c.57-.69.86-1.67.86-2.94s-.29-2.27-.86-2.97c-.57-.69-1.38-1.04-2.45-1.04Zm11.84,9.36c-1.52,0-2.73-.48-3.64-1.43-.9-.96-1.35-2.23-1.35-3.82,0-1.72.47-3.07,1.41-4.04.94-.97,2.21-1.45,3.82-1.45s2.72.47,3.58,1.41c.86.94,1.29,2.25,1.29,3.92s-.46,2.95-1.39,3.94c-.92.98-2.16,1.47-3.72,1.47Zm.12-9.36c-1.06,0-1.89.36-2.51,1.08-.61.71-.92,1.7-.92,2.97s.31,2.17.93,2.88c.62.7,1.45,1.05,2.5,1.05s1.88-.34,2.45-1.03c.57-.69.86-1.67.86-2.94s-.29-2.27-.86-2.97c-.57-.69-1.38-1.04-2.45-1.04Zm22.12,9.12h-1.64v-5.89c0-1.14-.18-1.96-.53-2.47-.35-.51-.94-.76-1.76-.76-.7,0-1.3.32-1.79.96-.49.64-.73,1.41-.73,2.3v5.85h-1.64v-6.09c0-2.02-.78-3.03-2.33-3.03-.72,0-1.32.3-1.78.91-.47.6-.7,1.39-.7,2.35v5.85h-1.64v-10.26h1.64v1.62h.04c.73-1.24,1.79-1.86,3.19-1.86.7,0,1.31.2,1.83.59.52.39.88.9,1.07,1.53.76-1.42,1.9-2.12,3.41-2.12,2.26,0,3.39,1.39,3.39,4.18v6.32Z" />
				<path d="m590.85,352.81c0,.96-.09,1.81-.28,2.56-.19.74-.47,1.38-.83,1.9-.36.52-.81.91-1.33,1.18-.53.27-1.12.4-1.79.4s-1.3-.12-1.82-.36v-1.14c.58.33,1.2.49,1.85.49.47,0,.89-.1,1.26-.29.37-.19.69-.48.95-.85.26-.37.45-.83.59-1.38.14-.54.2-1.17.2-1.87h-.03c-.45.9-1.23,1.35-2.33,1.35-.45,0-.86-.08-1.23-.23-.37-.16-.7-.38-.97-.67-.27-.29-.48-.64-.63-1.04-.15-.4-.23-.84-.23-1.32,0-.52.08-.99.25-1.41.17-.43.4-.79.7-1.1.3-.31.66-.55,1.06-.72.41-.17.86-.26,1.35-.26.53,0,.99.11,1.39.32.41.21.75.52,1.03.93.28.4.49.9.63,1.49.15.59.22,1.27.22,2.03Zm-1.29-1.07c0-.4-.05-.77-.16-1.1-.1-.33-.25-.61-.43-.85-.18-.24-.41-.42-.66-.55-.25-.13-.53-.2-.83-.2s-.55.06-.8.18c-.25.11-.46.27-.65.48-.18.2-.32.45-.43.74-.1.28-.15.59-.15.93,0,.37.05.7.15.99.1.29.25.54.43.74.18.2.41.35.66.46.26.11.55.16.87.16.28,0,.54-.05.78-.15.25-.11.46-.25.64-.42.18-.18.33-.39.43-.63.11-.24.16-.5.16-.78Z" />
				<rect x="592.77" y="348.21" width="1.06" height="3.26" />
				<path d="m601.92,355.71c0,.47-.09.9-.27,1.29-.18.38-.43.71-.75.99-.32.27-.71.48-1.16.63-.45.15-.95.23-1.49.23-1,0-1.79-.19-2.38-.57v-1.28c.7.55,1.51.83,2.42.83.36,0,.69-.05.98-.14.3-.09.55-.23.76-.4.21-.18.38-.39.49-.63.12-.25.18-.53.18-.84,0-1.37-.97-2.05-2.92-2.05h-.87v-1.01h.82c1.72,0,2.58-.64,2.58-1.93,0-1.19-.66-1.78-1.97-1.78-.74,0-1.43.25-2.08.74v-1.16c.67-.4,1.46-.6,2.38-.6.44,0,.83.06,1.19.18.35.12.66.29.91.51s.45.48.58.79c.14.31.21.64.21,1.01,0,1.38-.7,2.26-2.09,2.65v.03c.35.04.68.13.98.26.3.13.56.3.78.52.22.21.39.47.51.76.13.29.19.61.19.96Z" />
				<path d="m605.27,348.21v3.26h-1.06v-3.26h1.06Zm2.42,0v3.26h-1.06v-3.26h1.06Z" />
				<path d="m619.64,351.2l-2.51,3.78,2.46,3.69h-1.39l-1.47-2.42c-.09-.15-.2-.34-.33-.57h-.03s-.14.23-.34.57l-1.49,2.42h-1.38l2.55-3.66-2.44-3.81h1.39l1.44,2.55c.11.19.21.38.31.58h.03l1.87-3.14h1.32Z" />
				<path d="m629.55,350.95c0-.32-.05-.6-.15-.84-.1-.24-.23-.44-.41-.59-.17-.16-.37-.28-.61-.36-.23-.08-.49-.12-.76-.12-.23,0-.46.03-.69.09-.22.06-.44.15-.66.26-.21.11-.41.25-.61.4-.19.16-.38.33-.55.52v-1.28c.34-.33.71-.57,1.12-.74.42-.18.93-.26,1.52-.26.43,0,.82.06,1.19.19.36.12.68.3.95.54.27.24.48.53.63.88.16.35.23.75.23,1.2,0,.41-.05.79-.15,1.12-.09.34-.24.65-.43.95-.19.3-.43.58-.72.85-.29.27-.63.55-1.03.83-.49.35-.9.65-1.22.9-.32.25-.57.48-.76.7-.18.21-.32.43-.39.65-.07.21-.11.46-.11.74h5.21v1.07h-6.45v-.52c0-.45.05-.84.15-1.18.1-.34.26-.66.48-.97.22-.31.52-.61.88-.92.36-.31.81-.65,1.33-1.04.38-.27.7-.53.95-.78.26-.25.46-.5.62-.74.16-.25.26-.5.33-.75.07-.26.1-.53.1-.82Zm9.38,4.75c0,.47-.09.9-.27,1.29-.17.38-.43.71-.75.99-.32.27-.71.48-1.16.63-.45.15-.95.23-1.49.23-1,0-1.79-.19-2.38-.57v-1.28c.7.55,1.51.83,2.42.83.36,0,.69-.05.98-.14.3-.09.55-.23.76-.4.21-.18.38-.39.49-.63.12-.25.18-.53.18-.84,0-1.37-.97-2.05-2.92-2.05h-.87v-1.01h.82c1.72,0,2.58-.64,2.58-1.93,0-1.19-.66-1.78-1.97-1.78-.74,0-1.43.25-2.08.74v-1.16c.67-.4,1.46-.6,2.38-.6.44,0,.83.06,1.19.18.35.12.66.29.91.51.25.22.45.48.58.79.14.31.21.64.21,1.01,0,1.38-.7,2.26-2.09,2.65v.03c.35.04.68.13.98.26.3.13.56.3.78.52.22.21.39.47.51.76.13.29.19.61.19.96Z" />
				<rect x="641.23" y="348.21" width="1.06" height="3.26" />
				<path d="m650.86,353.39c0,.88-.08,1.65-.24,2.33-.16.68-.38,1.25-.69,1.71-.3.46-.66.81-1.1,1.06-.43.24-.93.36-1.48.36-.53,0-.99-.11-1.41-.34-.41-.23-.75-.57-1.04-1.01-.28-.44-.5-.98-.64-1.63-.15-.65-.22-1.39-.22-2.22,0-.91.08-1.72.23-2.42.16-.7.38-1.29.68-1.76.3-.48.66-.83,1.1-1.07.44-.24.95-.36,1.52-.36,2.19,0,3.29,1.79,3.29,5.36Zm-1.23.12c0-2.98-.71-4.46-2.12-4.46-1.49,0-2.24,1.51-2.24,4.54,0,2.82.73,4.24,2.2,4.24s2.17-1.44,2.17-4.32Z" />
				<path d="m653.73,348.21v3.26h-1.06v-3.26h1.06Zm2.42,0v3.26h-1.06v-3.26h1.06Z" />
				<path d="m339.48,197.38v-14.37h4.09c1.24,0,2.23.3,2.96.91.73.61,1.09,1.4,1.09,2.37,0,.82-.22,1.52-.66,2.12-.44.6-1.05,1.03-1.82,1.28v.04c.97.11,1.74.48,2.32,1.1.58.61.87,1.42.87,2.4,0,1.23-.44,2.22-1.32,2.99-.88.76-1.99,1.14-3.34,1.14h-4.19Zm1.68-12.85v4.64h1.72c.92,0,1.65-.22,2.17-.66.53-.45.79-1.08.79-1.88,0-1.4-.92-2.09-2.76-2.09h-1.93Zm0,6.15v5.17h2.28c.99,0,1.75-.23,2.29-.7.55-.47.82-1.11.82-1.92,0-1.7-1.16-2.55-3.47-2.55h-1.93Zm18.08,1.97h-7.24c.03,1.14.33,2.02.92,2.65s1.4.93,2.42.93c1.16,0,2.22-.38,3.19-1.14v1.54c-.9.65-2.09.98-3.58.98s-2.59-.46-3.42-1.39c-.83-.94-1.24-2.25-1.24-3.94,0-1.6.45-2.9,1.35-3.9.91-1.01,2.03-1.51,3.38-1.51s2.38.43,3.12,1.3,1.1,2.07,1.1,3.62v.86Zm-1.68-1.39c0-.95-.24-1.69-.69-2.21-.45-.53-1.07-.79-1.87-.79s-1.43.28-1.97.83c-.54.55-.88,1.28-1,2.17h5.54Zm12.91,6.11h-1.64v-1.74h-.04c-.76,1.32-1.94,1.98-3.53,1.98-1.29,0-2.32-.46-3.1-1.37-.77-.92-1.15-2.17-1.15-3.76,0-1.7.43-3.06,1.28-4.08s1.99-1.53,3.42-1.53,2.44.55,3.08,1.66h.04v-6.35h1.64v15.19Zm-1.64-4.64v-1.51c0-.83-.27-1.53-.82-2.1-.55-.57-1.24-.86-2.08-.86-1,0-1.79.37-2.36,1.1-.57.73-.86,1.75-.86,3.05,0,1.18.27,2.12.82,2.81.55.68,1.3,1.02,2.22,1.02s1.66-.33,2.22-.99c.57-.66.86-1.5.86-2.51Zm10.31-3.96c-.29-.22-.7-.33-1.24-.33-.7,0-1.29.33-1.76.99-.47.66-.7,1.56-.7,2.71v5.23h-1.64v-10.26h1.64v2.11h.04c.23-.72.59-1.28,1.07-1.68.48-.41,1.02-.61,1.61-.61.43,0,.75.05.98.14v1.7Zm6.06,8.84c-1.52,0-2.73-.48-3.64-1.43-.9-.96-1.35-2.23-1.35-3.82,0-1.72.47-3.07,1.41-4.04.94-.97,2.21-1.45,3.82-1.45s2.72.47,3.58,1.41c.86.94,1.29,2.25,1.29,3.92s-.46,2.95-1.39,3.94c-.92.98-2.16,1.47-3.72,1.47Zm.12-9.36c-1.06,0-1.89.36-2.51,1.08-.61.71-.92,1.7-.92,2.97s.31,2.17.93,2.88c.62.7,1.45,1.05,2.5,1.05s1.88-.34,2.45-1.03c.57-.69.86-1.67.86-2.94s-.29-2.27-.86-2.97c-.57-.69-1.38-1.04-2.45-1.04Zm11.89,9.36c-1.52,0-2.73-.48-3.64-1.43-.9-.96-1.35-2.23-1.35-3.82,0-1.72.47-3.07,1.41-4.04.94-.97,2.21-1.45,3.82-1.45s2.72.47,3.58,1.41c.86.94,1.29,2.25,1.29,3.92s-.46,2.95-1.39,3.94c-.92.98-2.16,1.47-3.72,1.47Zm.12-9.36c-1.06,0-1.89.36-2.51,1.08-.61.71-.92,1.7-.92,2.97s.31,2.17.93,2.88c.62.7,1.45,1.05,2.5,1.05s1.88-.34,2.44-1.03c.57-.69.86-1.67.86-2.94s-.29-2.27-.86-2.97c-.57-.69-1.38-1.04-2.44-1.04Zm22.17,9.12h-1.64v-5.89c0-1.14-.18-1.96-.53-2.47-.35-.51-.94-.76-1.76-.76-.7,0-1.3.32-1.79.96-.49.64-.73,1.41-.73,2.3v5.85h-1.64v-6.09c0-2.02-.78-3.03-2.33-3.03-.72,0-1.32.3-1.78.91-.47.6-.7,1.39-.7,2.35v5.85h-1.64v-10.26h1.64v1.62h.04c.73-1.24,1.79-1.86,3.19-1.86.7,0,1.31.2,1.83.59.52.39.88.9,1.07,1.53.76-1.42,1.9-2.12,3.41-2.12,2.26,0,3.39,1.39,3.39,4.18v6.32Z" />
				<path d="m343.59,218.67h-1.2v-9.04c-.09.09-.23.2-.41.32-.18.12-.37.23-.6.35-.22.12-.45.23-.7.33-.24.1-.48.18-.71.24v-1.21c.26-.07.54-.17.83-.29.3-.13.59-.26.87-.42.29-.16.56-.32.81-.48.25-.17.47-.34.66-.5h.45v10.69Zm10.22-5.27c0,.88-.08,1.65-.24,2.33-.16.68-.38,1.25-.69,1.71-.3.46-.66.81-1.1,1.06-.43.24-.93.36-1.48.36-.53,0-.99-.11-1.41-.34-.41-.23-.75-.57-1.04-1.01-.28-.44-.5-.98-.64-1.63-.15-.65-.22-1.39-.22-2.22,0-.91.08-1.72.23-2.42.16-.7.38-1.29.68-1.76.3-.48.66-.83,1.1-1.07.44-.24.95-.36,1.52-.36,2.19,0,3.29,1.79,3.29,5.36Zm-1.23.12c0-2.98-.71-4.46-2.12-4.46-1.49,0-2.24,1.51-2.24,4.54,0,2.82.73,4.24,2.19,4.24s2.17-1.44,2.17-4.32Z" />
				<rect x="355.61" y="208.22" width="1.06" height="3.26" />
				<path d="m364.01,208.22v6.91h1.34v1.09h-1.34v2.46h-1.18v-2.46h-4.91v-1.04c.46-.52.92-1.06,1.39-1.65.47-.59.91-1.18,1.33-1.79.43-.6.82-1.2,1.18-1.8.36-.6.67-1.18.92-1.73h1.28Zm-4.75,6.91h3.57v-5.12c-.36.64-.71,1.21-1.04,1.71-.33.5-.64.96-.93,1.36-.29.41-.57.78-.84,1.11-.27.33-.52.64-.76.94Z" />
				<path d="m368.11,208.22v3.26h-1.06v-3.26h1.06Zm2.42,0v3.26h-1.06v-3.26h1.06Z" />
				<path d="m382.48,211.21l-2.51,3.78,2.46,3.69h-1.39l-1.47-2.42c-.09-.15-.2-.34-.33-.57h-.03s-.14.23-.34.57l-1.49,2.42h-1.38l2.54-3.66-2.44-3.81h1.39l1.44,2.55c.11.19.21.38.31.58h.03l1.87-3.14h1.32Z" />
				<path d="m392.04,218.67h-1.2v-9.04c-.09.09-.23.2-.41.32-.18.12-.37.23-.6.35-.22.12-.45.23-.7.33-.24.1-.48.18-.71.24v-1.21c.26-.07.54-.17.83-.29.3-.13.59-.26.87-.42.29-.16.56-.32.81-.48.25-.17.47-.34.66-.5h.45v10.69Zm9.73-2.96c0,.47-.09.9-.27,1.29-.17.38-.43.71-.75.99-.32.27-.71.48-1.16.63-.45.15-.95.23-1.49.23-1,0-1.79-.19-2.38-.57v-1.28c.7.55,1.51.83,2.42.83.36,0,.69-.05.98-.14.3-.09.55-.23.76-.4.21-.18.38-.39.49-.63.12-.25.18-.53.18-.84,0-1.37-.97-2.05-2.92-2.05h-.87v-1.01h.82c1.72,0,2.58-.64,2.58-1.93,0-1.19-.66-1.78-1.97-1.78-.74,0-1.43.25-2.08.74v-1.16c.67-.4,1.46-.6,2.38-.6.44,0,.83.06,1.19.18.35.12.66.29.91.51.25.22.45.48.58.79.14.31.21.64.21,1.01,0,1.38-.7,2.26-2.09,2.65v.03c.35.04.68.13.98.26.3.13.56.3.78.52.22.21.39.47.51.76.13.29.19.61.19.96Z" />
				<rect x="404.07" y="208.22" width="1.06" height="3.26" />
				<path d="m411.55,218.67h-1.2v-9.04c-.09.09-.23.2-.41.32-.17.12-.37.23-.6.35-.22.12-.45.23-.7.33-.24.1-.48.18-.71.24v-1.21c.26-.07.54-.17.83-.29.3-.13.59-.26.87-.42.29-.16.56-.32.81-.48.25-.17.47-.34.66-.5h.45v10.69Z" />
				<path d="m416.57,208.22v3.26h-1.06v-3.26h1.06Zm2.42,0v3.26h-1.06v-3.26h1.06Z" />
				<path d="m452.68,579.51h-2.34l-5.55-6.57c-.21-.25-.33-.41-.38-.5h-.04v7.07h-1.68v-14.37h1.68v6.75h.04c.09-.15.22-.31.38-.49l5.37-6.26h2.09l-6.16,6.89,6.59,7.48Zm2.51-12.87c-.29,0-.54-.1-.75-.3-.21-.2-.31-.45-.31-.76s.1-.56.31-.76c.21-.21.46-.31.75-.31s.55.1.76.31c.21.2.32.45.32.76s-.11.54-.32.75c-.21.21-.46.31-.76.31Zm.8,12.87h-1.64v-10.26h1.64v10.26Zm8.07-.1c-.39.21-.9.32-1.53.32-1.8,0-2.7-1-2.7-3.01v-6.07h-1.76v-1.4h1.76v-2.51l1.64-.53v3.04h2.59v1.4h-2.59v5.78c0,.69.12,1.18.35,1.47.23.29.62.44,1.16.44.41,0,.77-.11,1.07-.34v1.4Zm9.18-.37c-.79.47-1.72.71-2.81.71-1.46,0-2.65-.47-3.55-1.42-.9-.96-1.34-2.19-1.34-3.71,0-1.69.48-3.05,1.45-4.07.97-1.03,2.26-1.54,3.88-1.54.9,0,1.7.17,2.38.5v1.68c-.76-.53-1.58-.8-2.45-.8-1.05,0-1.91.38-2.59,1.13-.67.75-1,1.73-1,2.96s.31,2.15.94,2.85c.63.69,1.48,1.04,2.55,1.04.9,0,1.74-.3,2.53-.89v1.56Zm10.99.47h-1.64v-5.91c0-2.14-.79-3.21-2.38-3.21-.8,0-1.48.31-2.02.93-.55.61-.82,1.41-.82,2.37v5.81h-1.64v-15.19h1.64v6.63h.04c.79-1.3,1.91-1.94,3.37-1.94,2.31,0,3.47,1.39,3.47,4.18v6.32Zm11.33-4.72h-7.24c.03,1.14.33,2.02.92,2.65.59.62,1.4.93,2.43.93,1.16,0,2.22-.38,3.19-1.14v1.54c-.9.65-2.09.98-3.58.98s-2.59-.46-3.42-1.39c-.83-.94-1.24-2.25-1.24-3.94,0-1.6.45-2.9,1.35-3.9.91-1.01,2.03-1.51,3.38-1.51s2.38.43,3.12,1.3c.73.87,1.1,2.07,1.1,3.62v.86Zm-1.68-1.39c0-.95-.24-1.69-.69-2.21-.45-.53-1.07-.79-1.87-.79s-1.43.28-1.97.83c-.54.55-.88,1.28-1,2.17h5.54Zm12.67,6.11h-1.64v-5.85c0-2.18-.79-3.27-2.38-3.27-.82,0-1.5.31-2.04.93-.53.61-.8,1.39-.8,2.33v5.85h-1.64v-10.26h1.64v1.7h.04c.77-1.3,1.9-1.94,3.37-1.94,1.12,0,1.98.36,2.58,1.09.59.72.89,1.77.89,3.14v6.27Z" />
				<path d="m663.33,852.76v-14.37h4.09c1.24,0,2.23.3,2.96.91s1.09,1.4,1.09,2.37c0,.82-.22,1.52-.66,2.12-.44.6-1.05,1.03-1.82,1.28v.04c.97.11,1.74.48,2.32,1.1.58.61.87,1.42.87,2.4,0,1.23-.44,2.22-1.32,2.99-.88.76-1.99,1.14-3.34,1.14h-4.19Zm1.68-12.85v4.64h1.72c.92,0,1.65-.22,2.17-.66.53-.45.79-1.08.79-1.88,0-1.4-.92-2.09-2.76-2.09h-1.93Zm0,6.15v5.17h2.28c.99,0,1.75-.23,2.29-.7.55-.47.82-1.11.82-1.92,0-1.7-1.16-2.55-3.47-2.55h-1.93Zm17.2,6.69h-1.64v-1.6h-.04c-.71,1.23-1.77,1.84-3.16,1.84-1.02,0-1.82-.27-2.4-.81-.57-.54-.86-1.26-.86-2.15,0-1.92,1.13-3.03,3.39-3.35l3.08-.43c0-1.74-.7-2.62-2.11-2.62-1.24,0-2.35.42-3.35,1.26v-1.68c1.01-.64,2.17-.96,3.49-.96,2.41,0,3.62,1.28,3.62,3.83v6.67Zm-1.64-5.19l-2.48.34c-.76.11-1.34.3-1.72.57-.39.27-.58.74-.58,1.43,0,.5.18.91.53,1.23.36.31.84.47,1.43.47.82,0,1.49-.28,2.01-.85.53-.57.8-1.3.8-2.17v-1.02Zm9.5,5.09c-.39.21-.9.32-1.53.32-1.8,0-2.7-1-2.7-3.01v-6.07h-1.76v-1.4h1.76v-2.51l1.64-.53v3.04h2.59v1.4h-2.59v5.78c0,.69.12,1.18.35,1.47s.62.44,1.16.44c.41,0,.77-.11,1.07-.34v1.4Zm10.71.1h-1.64v-5.91c0-2.14-.79-3.21-2.38-3.21-.8,0-1.48.31-2.02.93-.55.61-.82,1.41-.82,2.37v5.81h-1.64v-15.19h1.64v6.63h.04c.79-1.3,1.91-1.94,3.37-1.94,2.31,0,3.47,1.39,3.47,4.18v6.32Z" />
				<path d="m407.14,769.47h-7.62v-14.37h7.29v1.52h-5.61v4.78h5.19v1.51h-5.19v5.03h5.93v1.52Zm11.08,0h-1.64v-5.85c0-2.18-.79-3.27-2.38-3.27-.82,0-1.5.31-2.04.93-.53.61-.8,1.39-.8,2.33v5.85h-1.64v-10.26h1.64v1.7h.04c.77-1.3,1.9-1.94,3.37-1.94,1.12,0,1.98.36,2.58,1.09.59.72.89,1.77.89,3.14v6.27Zm7.87-.1c-.39.21-.9.32-1.53.32-1.8,0-2.7-1-2.7-3.01v-6.07h-1.76v-1.4h1.76v-2.51l1.64-.53v3.04h2.59v1.4h-2.59v5.78c0,.69.12,1.18.35,1.47.23.29.62.44,1.16.44.41,0,.77-.11,1.07-.34v1.4Zm7.56-8.5c-.29-.22-.7-.33-1.24-.33-.7,0-1.29.33-1.76.99-.47.66-.7,1.56-.7,2.71v5.23h-1.64v-10.26h1.64v2.11h.04c.23-.72.59-1.28,1.07-1.68.48-.41,1.02-.61,1.61-.61.43,0,.75.05.98.14v1.7Zm9.97-1.66l-4.72,11.9c-.84,2.12-2.02,3.19-3.55,3.19-.43,0-.78-.04-1.07-.13v-1.47c.35.12.68.18.97.18.83,0,1.45-.49,1.86-1.48l.82-1.94-4.01-10.24h1.82l2.78,7.9c.03.1.1.36.21.78h.06c.03-.16.1-.41.2-.76l2.92-7.92h1.7Z" />
				<path d="m478.86,869.66l-2.58,9.15h-1.26l-1.88-6.69c-.08-.28-.13-.6-.15-.93h-.03c-.03.31-.08.62-.17.92l-1.89,6.7h-1.24l-2.68-9.15h1.18l1.95,7.02c.08.29.13.6.15.92h.03c.02-.23.09-.53.2-.92l2.02-7.02h1.03l1.94,7.07c.07.24.12.53.15.85h.03c.02-.22.07-.51.17-.88l1.87-7.04h1.16Z" />
				<polygon points="484.19 869.66 479.8 880.33 478.82 880.33 483.2 869.66 484.19 869.66" />
				<path d="m485.25,878.81v-9.15h2.53c3.22,0,4.84,1.49,4.84,4.46,0,1.41-.45,2.55-1.35,3.41-.89.85-2.09,1.28-3.59,1.28h-2.42Zm1.07-8.18v7.21h1.37c1.2,0,2.13-.32,2.8-.96.67-.64,1-1.55,1-2.73,0-2.34-1.25-3.51-3.74-3.51h-1.43Z" />
			</g>
		</g>
	)
}

export default PlanL
